// 웹(데스크톱) 화면 글자 크기 배율 — 사용자가 직접 조절(브라우저별 localStorage 저장).
// MobileScale(적용)·SidebarViewControls(사이드바 하단 −/+ 조절 UI) 공용. 변경 시 커스텀 이벤트로 즉시 반영.
// 모바일 배율(utils/mobileZoom · gwMobileZoom)과 따로 저장한다 — 이 파일은 gwMobileZoom 을 읽지도 쓰지도 않는다.
// 상수에 DESKTOP_ 접두를 붙인다 — SidebarViewControls 가 mobileZoom 과 함께 import 한다.
const KEY = 'gwDesktopZoom';
export const DESKTOP_ZOOM_EVENT = 'gw-desktopzoom';
export const DESKTOP_ZOOM_MIN = 0.8;
export const DESKTOP_ZOOM_MAX = 1.5;
export const DESKTOP_ZOOM_STEP = 0.1;
// 기본 1.0 = 배율 미적용(MobileScale 이 <html> 인라인 값을 건드리지 않는다).
export const DESKTOP_ZOOM_DEFAULT = 1.0;

export function getDesktopZoom() {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === null) return DESKTOP_ZOOM_DEFAULT;
    const v = Number.parseFloat(stored);
    return (v >= DESKTOP_ZOOM_MIN && v <= DESKTOP_ZOOM_MAX) ? v : DESKTOP_ZOOM_DEFAULT;
  } catch (e) { return DESKTOP_ZOOM_DEFAULT; }
}

// 배율 설정(범위 클램프 + 소수1자리 반올림). 반환=적용된 값. 전 구독자(MobileScale 등) 즉시 갱신.
export function setDesktopZoom(v) {
  let z = Math.round(v * 10) / 10;
  if (z < DESKTOP_ZOOM_MIN) z = DESKTOP_ZOOM_MIN;
  if (z > DESKTOP_ZOOM_MAX) z = DESKTOP_ZOOM_MAX;
  try { localStorage.setItem(KEY, String(z)); } catch (e) { /* */ }
  try { window.dispatchEvent(new Event(DESKTOP_ZOOM_EVENT)); } catch (e) { /* */ }
  return z;
}
